import type { FC } from 'react';

export const Logo: FC = () => (
  <svg
    width="163"
    height="44"
    viewBox="0 0 163 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.9102 31.7863C64.7854 31.7863 60.6209 27.6218 60.6209 22.497C60.6209 17.377 64.7854 13.2077 69.9102 13.2077C71.3965 13.2077 72.878 13.5696 74.1906 14.25C75.4597 14.9111 76.5744 15.8714 77.4189 17.0296L76.0532 18.0237C74.6249 16.0645 72.3279 14.8967 69.9102 14.8967C65.7168 14.8967 62.3099 18.3084 62.3099 22.497C62.3099 26.6905 65.7168 30.0974 69.9102 30.0974C72.3761 30.0974 74.6972 28.8958 76.1208 26.8787L77.5009 27.8535C75.7589 30.3194 72.9214 31.7863 69.9102 31.7863ZM134.771 14.7471C134.771 15.5143 134.144 16.1417 133.372 16.1417C132.6 16.1417 131.973 15.5143 131.973 14.7471C131.973 13.975 132.6 13.3476 133.372 13.3476C134.144 13.3476 134.771 13.975 134.771 14.7471ZM111.444 28.9585C111.71 29.7355 112.627 31.5499 115.387 31.5499C115.942 31.5499 116.762 31.463 117.534 31.0625C118.355 30.633 119.329 29.721 119.329 27.8197C119.329 25.3345 116.738 24.3838 115.628 23.9785L115.58 23.9592C114.383 23.5201 113.394 23.0471 113.394 21.6477C113.394 20.3979 114.436 19.7223 115.411 19.7223C116.617 19.7223 117.283 20.4461 117.626 21.0542L119.098 20.2242C118.311 18.8344 116.97 18.0333 115.411 18.0333C113.587 18.0333 111.705 19.3893 111.705 21.6477C111.705 22.8107 112.139 23.7662 112.988 24.4852C113.664 25.0594 114.465 25.3538 114.996 25.5468L115.044 25.5661C116.304 26.0245 117.64 26.6181 117.64 27.8197C117.64 28.9634 117.129 29.3639 116.748 29.5666C116.386 29.7548 115.903 29.8609 115.387 29.8609C114.156 29.8609 113.37 29.3735 113.042 28.4132L111.444 28.9585ZM104.597 18.3808C103.709 18.5786 102.86 19.1529 102.184 19.8622V18.5449H100.495V31.159H102.184V29.4652V24.6058C102.194 23.9302 102.295 22.7769 102.507 22.3185C102.942 21.363 103.979 20.2483 104.964 20.0311C105.441 19.925 105.856 20.0408 106.266 20.3931L107.367 19.1094C106.551 18.4097 105.596 18.1588 104.597 18.3808ZM132.527 18.6606H134.216V31.159H132.527V18.6606ZM108.766 16.272C109.538 16.272 110.166 15.6446 110.166 14.8774C110.166 14.1053 109.538 13.4779 108.766 13.4779C107.994 13.4779 107.367 14.1053 107.367 14.8774C107.367 15.6446 107.994 16.272 108.766 16.272ZM107.922 18.7909H109.611V31.2893H107.922V18.7909ZM81.926 13.4538H80.2371V31.1542H81.926V13.4538ZM122.268 31.2121H131.003V29.5231H123.957V13.7337H122.268V31.2121ZM148.602 22.9217C148.602 22.8734 148.577 21.6767 147.974 20.4848C147.39 19.3314 146.16 17.9561 143.622 17.9561C142.695 17.9561 141.706 18.2939 140.77 18.9406C140.089 19.4038 139.467 20.0118 138.979 20.6826V18.54H137.29V31.1542H138.979V26.3672H138.994C139.052 25.5661 139.365 23.2209 140.118 22.0096C140.852 20.8322 142.29 19.6451 143.626 19.6451C144.978 19.6451 145.899 20.1566 146.454 21.2038C146.888 22.0289 146.922 22.8879 146.922 22.941V31.1542H148.611V22.9313L148.602 22.9217ZM96.2726 20.311V18.5448H97.9615V31.1542H96.2726V29.1467C95.042 30.5462 93.2421 31.4292 91.2394 31.4292C87.543 31.4292 84.5366 28.4229 84.5366 24.7265C84.5366 21.0349 87.543 18.0285 91.2394 18.0285C93.2421 18.0285 95.042 18.9116 96.2726 20.311ZM86.2304 24.7265C86.2304 27.4915 88.4792 29.7403 91.2443 29.7403C94.0045 29.7403 96.2533 27.4915 96.2581 24.7265C96.2581 21.9662 94.0093 19.7175 91.2443 19.7175C88.4792 19.7175 86.2304 21.9614 86.2304 24.7265ZM153.393 26.1114V31.2604H151.704V13.4538H153.393V23.1099L158.509 18.3566H160.994L154.243 24.6251L162.466 31.2604H159.778L153.393 26.1114Z"
        fill="#1D2088"
      />
      <g clipPath="url(#clip1)">
        <path
          d="M0 22.3764C0 27.6363 1.81443 32.4764 4.85457 36.2935C9.01426 36.1777 12.9278 37.857 15.7074 40.7234C16.272 40.5207 16.8559 40.3567 17.4639 40.2408C21.585 39.4591 25.5999 41.0274 28.1478 44C30.966 43.2472 33.567 41.9636 35.835 40.2553L29.4749 36.1198C27.3516 37.22 24.934 37.8425 22.3764 37.8425C13.835 37.8425 6.91511 30.9177 6.91511 22.3764C6.91511 13.8351 13.8399 6.91511 22.3764 6.91511C23.0761 6.91511 23.7662 6.96337 24.4418 7.05023L26.1211 0.313665C24.9002 0.106164 23.6504 0 22.3764 0C10.018 0 0 10.018 0 22.3764Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M32.0083 1.94956L29.0985 15.3358C28.6787 17.2613 29.3349 17.5749 30.5558 16.0211L32.9879 12.9327C34.2088 11.3836 36.4045 10.3413 37.8715 10.6212C39.3384 10.9011 39.6955 9.75259 38.6629 8.06845L34.6431 1.50561C34.175 0.738333 33.6732 0.36676 33.2292 0.36676C32.6936 0.36676 32.24 0.902404 32.0083 1.94956Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M23.385 10.6598L15.9005 12.455C13.9847 12.9134 13.8013 14.115 15.4951 15.1235L27.0573 21.9856C28.7511 22.9941 29.2723 22.4536 28.2154 20.7936L26.1887 17.6135C25.127 15.9487 24.8472 13.5166 25.5662 12.2089C26.1356 11.1762 25.6386 10.5247 24.4611 10.5247C24.1474 10.5151 23.7855 10.5633 23.385 10.6598Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M21.1217 25.8943L20.5185 33.567C20.3641 35.531 21.4547 36.086 22.9458 34.7927L33.0651 26.0197C34.5563 24.7265 34.2088 24.0557 32.293 24.5238L28.6111 25.4213C26.6953 25.8894 24.2922 25.3827 23.2691 24.297C22.9458 23.9544 22.6273 23.7903 22.3378 23.7903C21.7105 23.7903 21.2279 24.5527 21.1217 25.8943Z"
          fill="url(#paint3_linear)"
        />
        <path
          d="M37.0897 21.4837L36.834 25.4165C36.7037 27.3854 35.4973 29.5135 34.1461 30.1505C32.7949 30.7875 33.181 31.9263 35.005 32.6791L42.118 35.6227C43.9421 36.3804 44.801 35.5117 44.0289 33.6925L38.7256 21.2086C38.3588 20.3496 38.0066 19.925 37.717 19.925C37.3937 19.925 37.1573 20.451 37.0897 21.4837Z"
          fill="url(#paint4_linear)"
        />
        <path
          d="M49.4626 13.3862L35.7 14.7181C33.7359 14.9063 33.6442 15.6205 35.4973 16.3058L39.3288 17.7197C41.1819 18.4049 42.8467 20.1711 43.0349 21.6525C43.2231 23.134 44.4247 23.1195 45.7083 21.6188L50.7076 15.7653C51.8899 14.3803 51.5039 13.3621 49.8969 13.3621C49.757 13.3669 49.6122 13.3718 49.4626 13.3862Z"
          fill="url(#paint5_linear)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="17.9166"
        y1="0"
        x2="17.9166"
        y2="44.001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D2088" />
        <stop offset="1" stopColor="#004EA2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="36.6708"
        y1="1.09046"
        x2="33.0482"
        y2="17.8207"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F39800" />
        <stop offset="1" stopColor="#FFD900" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="16.1701"
        y1="10.3858"
        x2="30.6841"
        y2="19.0035"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F39800" />
        <stop offset="1" stopColor="#FFD900" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="18.6527"
        y1="32.6733"
        x2="31.3398"
        y2="21.6047"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F39800" />
        <stop offset="1" stopColor="#FFD900" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="40.7285"
        y1="37.1238"
        x2="33.9892"
        y2="21.5072"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F39800" />
        <stop offset="1" stopColor="#FFD900" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="51.7226"
        y1="17.5232"
        x2="34.5626"
        y2="19.2778"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F39800" />
        <stop offset="1" stopColor="#FFD900" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="162.464" height="44" fill="white" />
      </clipPath>
      <clipPath id="clip1">
        <rect width="51.3928" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
